var app = angular.module('app')
    .filter('expenseCostCenter', expenseCostCenter);

function expenseCostCenter () {
    return items => {
      var cost_center = null; 
      var mult_term = 'Split';
      
      if (items.length) {
          cost_center = items.reduce((prev, curr) => {
                  if (prev && 
                      (!curr.cost_center || prev != curr.cost_center.name)) {
                      prev = mult_term;
                  }

                  return prev;
              }, 
              items[0].cost_center && items[0].cost_center.name);
      }

      return cost_center;
    }
}